import { render, staticRenderFns } from "./Parametrizacoes.vue?vue&type=template&id=886c7852"
import script from "./Parametrizacoes.vue?vue&type=script&lang=js"
export * from "./Parametrizacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports